import { createContext, useContext, useState, useEffect } from "react";
import { translations, defaultLanguage } from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved language preference
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("agm-language");
      if (saved && translations[saved]) {
        return saved;
      }
    }
    return defaultLanguage;
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem("agm-language", language);
    // Update html lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];

  const switchLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
